module.exports = __webpack_public_path__ + "img/oxford-fire-logo.c58e8bad.jpg";